/**
 * @ngdoc filters
 * @memberof mercury.filters
 * @name quantity
 */
angular.module('mercury.filters.quantity', [])
.filter('quantity', function() {
  return function(num) {
    if (num == null) {
      return '';
    }

    return (+(Math.round(num + 'e+1') + 'e-1')).toString();
  };
});
